import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import { setLayerVisibility } from "../../../../../services/MapCore/LayerGroupService";
// import AppContext from "../../../../Contexts/AppContext";
import { LayerSettingsElement } from "./LayerSettingsElement";
import { useTranslation } from "react-i18next";
import "./LayerGroups.css";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import { OverflowTooltip } from "../../../../CustomComponents/OverflowTooltip/OverflowTooltip";
import { setLayerVisibility } from "../../../../services/MapCore/LayerGroupService";
import AppContext from "../../../../components/Contexts/AppContext";
import { OverflowTooltip } from "../../../../components/CustomComponents/OverflowTooltip/OverflowTooltip";

const LayerGroupSettingsElement = ({ layerGroup }) => {
  const { t, i18n } = useTranslation("main");
  const [hoverTools, setHoverTools] = useState(false);
  const [clickTools, setClickTools] = useState(false);
  const [layerVisibilityControl, setLayerVisibilityControl] = useState(
    layerGroup.visible
  );

  const { map, modeOptions } = useContext(AppContext);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const initialVisibility = {};
    layerGroup.layers.forEach((layer) => {
      initialVisibility[layer.id] = layer.visible;
    });
    setLayerVisibilityControl(initialVisibility ? 1 : 0);
  }, [layerGroup.layers]);

  const handleToggleLayerVisibility = (layerGroupId) => {
    const newVisibility = !layerVisibilityControl;
    layerGroup.visible = newVisibility;
    setLayerVisibilityControl(newVisibility);
    setLayerVisibility(map, layerGroupId, newVisibility);
  };
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return (
    <div style={{ marginBottom: "0rem" }}>
      <Accordion
        sx={{
          backgroundColor: layerVisibilityControl
            ? "var(--color-bg-3)"
            : "var(--color-txt-3)",
          color: layerVisibilityControl
            ? "var(--color-txt-3)"
            : "var(--color-bg-3)",
          borderRadius: 2,
          "&:before": {
            display: "none",
          },
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "& .MuiAccordionSummary-root": {
            borderRadius: 2,
          },
          ...(layerGroup.layers.some((layer) =>
            modeOptions.ASBESTOS_CLICK.includes(layer.id)
          ) && {
            outline: "2px solid #ff4081",
            outlineOffset: "-2px" /* Empuja el borde hacia adentro */,
          }),
        }}
        expanded={expanded}
        onChange={handleChange}
      >
        <AccordionSummary
          sx={{
            "& .MuiAccordionSummary-expandIconWrapper": {
              transform: "none !important", // Desactiva la rotación
              "&.Mui-expanded .accordionExpandIcon": {
                transform: "rotate(-180deg)",
              },
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            "& .MuiAccordionSummary-content": {
              overflow: "hidden",
            },
          }}
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexGrow: "1",
              overflow: "hidden",
            }}
          >
            <OverflowTooltip text={layerGroup.name[i18n.language]} />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              // gap: "1rem",
              paddingLeft: "8px",
            }}
          >
            {/* TODO ESTO COMENTADO ES PARA CUANDO SE PONGAN TOOLS DE LAYERGROUP */}
            {/* <div
              style={{
                display: "flex",
                maxWidth: clickTools || hoverTools ? "100px" : "0px",
                transition: "max-width 0.5s ease-in",
              }}
              onMouseEnter={() => setHoverTools(true)}
              onMouseLeave={() => setHoverTools(false)}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {layer.tools?.map((tool) => tool.button)}
            </div> */}

            {/* <IconButton
                sx={{
                  backgroundColor: clickTools
                    ? "grey!important"
                    : "transparent",

                  padding: "0",
                  transition: "transform 300ms ease-in-out",
                  transform: clickTools || hoverTools ? "rotate(90deg)" : 0,
                }}
                edge="end"
                onMouseEnter={() => setHoverTools(true)}
                onMouseLeave={() => setHoverTools(false)}
                onClick={(ev) => {
                  ev.stopPropagation();
                  setClickTools((prev) => !prev);
                }}
              >
                <MoreHorizIcon />
              </IconButton> */}
            <Tooltip title={t("toggle_visibility")}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleToggleLayerVisibility(layerGroup.id);
                }}
                aria-label="toggle visibility"
              >
                {layerVisibilityControl ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title={t(expanded ? "contract" : "expand")}>
              <IconButton
                className="accordionExpandIcon"
                sx={{
                  transform: expanded ? "rotate(180deg)" : "",
                  transition: "transform 0.3s ease-in-out!important",
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            </Tooltip>
          </div>
        </AccordionSummary>
        <AccordionDetails
          style={{
            backgroundColor: layerVisibilityControl ? "" : "#00000050",
          }}
        >
          {layerGroup.layers
            .map((layer, index) => {
              layer._originalIndex = index;
              return layer;
            })
            .sort((a, b) => {
              if (b.zIndex !== a.zIndex) return b.zIndex - a.zIndex;
              return b._originalIndex - a._originalIndex; // los de igual zIndex se ordenan al revés
            })
            .filter((layer) => layer.display)
            .map((layer) => {
              return (
                <LayerSettingsElement
                  key={layer.id}
                  layer={layer}
                  layerGroup={layerGroup}
                />
              );
            })}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export { LayerGroupSettingsElement };
